import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TIME_BUCKET_OPTIONS } from '../../services/dashboardTimeBucketService';

const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;

    label {
      width: 100%;
    }
  }
`;

const FieldLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-secondary);
`;

const StyledSelect = styled.select`
  min-width: 180px;
  max-width: 100%;
  padding: 0.45rem 0.75rem;
  border: 1px solid var(--color-border-primary);
  border-radius: 12px;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-size: 0.85rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  box-sizing: border-box;

  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }

  &:focus {
    outline: none;
    border-color: var(--color-secondary);
    box-shadow: 0 0 0 2px rgba(178, 190, 195, 0.25);
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--color-bg-secondary);
    color: var(--color-text-secondary);
    box-shadow: none;
  }
`;

const DashboardTimeBucketFilter = ({
  value,
  onChange,
  disabled = false,
  fieldId = 'dashboard-time-bucket-filter',
}) => (
  <FilterBar>
    <FieldLabel htmlFor={fieldId}>
      Agrupamento:
      <StyledSelect
        id={fieldId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {TIME_BUCKET_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
    </FieldLabel>
  </FilterBar>
);

DashboardTimeBucketFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fieldId: PropTypes.string,
};

export default DashboardTimeBucketFilter;
